import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import api from "../../api";
import {
  AppPermissions,
  CivilIdDetails,
  EmailAddress,
  Phone,
  State,
  useHasPermission,
} from "../../core";

import { Company, Customer } from "../../core/api/models";
import {
  ValidateEmail,
  ValidateNumber,
  ValidatePhoneNumberRegEx,
} from "../../utils/Validatation";

import { ExistingClient, SearchCustomer } from "../leads/components";
import CreateCustomer from "../leads/components/CreateCustomer";
import NewCustomerCreate from "../leads/components/NewCustomerCreate";
import { StatusCodes } from "http-status-codes";
import ExistingClientForNormalCustomer from "../customer/components/ExistingClient";
// ExistingClient but renamed 

const AddUser: React.FunctionComponent<{
  onClose?: () => void;
  customerCreated?: (id?: string) => void;
  companyId?: string;
  customer?: Customer;
  isCompany360?: boolean;
  isNormalCustomer?: boolean;
  isCompanyLead?: boolean | undefined;
  customerCreatedWithData?: (data?: Customer) => void;
}> = (props) => {
  const [seachValue, setSearchValue] = useState<string>();
  const [stage, setStage] = useState<string>("lead-details");

  const leadState = useSelector((state: State) => state.lead);

  const [customerDetails, setCustomerDetails] = useState<Customer | undefined>(
    props.customer!
  );
  const [phones, setPhones] = useState<Phone[] | undefined>();
  const [emails, setEmails] = useState<EmailAddress[] | undefined>();
  const [civilId, setCivilId] = useState("");
  const [searchPhone, setSearchPhone] = useState<string>();
  const [designationId, setDesignationId] = useState<string|null>(null);

  const canCreateCustomer = useHasPermission(AppPermissions.CreateCustomer);

  const onFetchDetails = (
    data: Customer,
    query: string,
    searchType?: string
  ) => {
    setDesignationId(null)
    setCustomerDetails(data);
    setPhones(undefined);
    setEmails(undefined);
    setCivilId("");

    setSearchPhone("");

    if (searchType === "mobile" && !data && ValidateNumber(query)) {
      setPhones([
        { phone: query, phoneType: "Mobile", isPrimary: true },
      ]);
    }
    if (searchType === "email" && !data && ValidateEmail(query)) {
      setEmails([{ email: query, emailType: "Business", isPrimary: true }]);
    }
    if (searchType === "civilId") {
      setCivilId(query);
    }
    if (data) {
      setPhones(data?.phones);
    }

    if (data && ValidatePhoneNumberRegEx(query) && searchType === "mobile") {
      setSearchPhone(query);
    }
    setStage(
      data || !canCreateCustomer ? "existing-customer" : "create-customer"
    );
  };

  const onAddExistingContactUser = async (data: Customer) => {
    setCustomerDetails(data);

    try {
      const response = await api.customer.addExistingCustomerAsCompanyContact({
        customerId: data._id!,
        companyId: props.companyId!,
      });
      if (response.status === StatusCodes.OK) {
        // reload();
        toastr.success("Success", "Contact added to company successfully");
        setStage("fetch-customer");
        // const leadResponse = await api.lead.getLead(
        //   leadState?.leadDetails?._id!
        // );
        // updateLeadDetails(leadResponse?.data);

        if(props.customerCreatedWithData){
          props.customerCreatedWithData(data)
        }
      } else {
        toastr.error(
          "Error",
          response?.message || "Error while adding contact"
        );
      }
    } catch (err) {
      toastr.error(
        "Error",
        "Error while adding contact possibly because the customer is contact of another company"
      );
    }
  };

  const createContactLessCustomer = (val:string) => {
    setDesignationId(val);
    setStage("create-customer");
  };

  return (
    <>
      <div className="detail-poupup bg-white position-fixed top-0 w-100 h-100 overflow-auto in">
        <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-9">
          <div className="row align-items-center">
            <div className="col-auto" onClick={props.onClose}>
              <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
            </div>
            <div className="col">
              <h5 className="mb-0">Add Contact</h5>
            </div>
          </div>
        </div>
        <div className="container-fluid px-0 h-100">
          <div className="row no-gutters h-100">
            <div className={stage === "create-customer" ? "col-12" : "col-md-auto border-right"}>
              {/* <CreateCustomer
                onCreateCustomer={(details: Customer) =>
                  props.customerCreated?.(details?._id)
                }
                companyId={props.companyId}
              ></CreateCustomer> */}
              {(stage === "add-new-user" || stage === "add-user") && (
                <>
                  <div className="col-md col-12 border-right ">
                    <div className="d-flex border-bottom align-items-center py-3 px-4">
                      <h6 className="mb-0">Add Contact</h6>
                    </div>
                    <NewCustomerCreate
                      // customerDetails={customerDetails}
                      onCreateCustomer={(details: Customer) =>
                       { props.customerCreated?.(details?._id) 
                        props.customerCreatedWithData?.(details) 
                       }
                      }
                      setStage={(stageName: string) => setStage(stageName)}
                      phones={phones}
                      // emails={emails}
                      companyId={props?.companyId}
                    ></NewCustomerCreate>
                  </div>
                  <div className="col-md-4 col-12"></div>
                </>
              )}
              {stage === "existing-customer" && (
                <>
                {props.isNormalCustomer === true ? 
                  <ExistingClientForNormalCustomer
                    isNormalCustomer={props.isNormalCustomer}
                    customerDetails={customerDetails}
                    setStage={(stageName: string) => setStage(stageName)}
                    phone={searchPhone}
                    onLeadClick={() => undefined}
                  ></ExistingClientForNormalCustomer>
                  : 
                  <ExistingClient
                    isCompanyLead={!!props.isCompanyLead}
                    addExistingCustomerAsUser={(details: Customer) =>
                      {
                        onAddExistingContactUser(details)
                        // if(props.customerCreated){
                        //   props.customerCreated(details._id);
                        // }
                      }
                    }
                    customerDetails={customerDetails}
                    setStage={(stageName: string) => setStage(stageName)}
                    phone={searchPhone}
                    onLeadClick={() => undefined}
                  ></ExistingClient>
                  }
                </>
              )}
              {stage === "lead-details" && (
                <div className="">
                  <SearchCustomer
                    onFetchDetails={(
                      details: Customer,
                      query: string,
                      searchType: string
                    ) => onFetchDetails(details, query, searchType)}
                    setStage={(stageName: string) => setStage(stageName)}
                    handleContactlessCustomer={createContactLessCustomer}
                  ></SearchCustomer>
                </div>
              )}
              {stage === "create-customer" && (
                <CreateCustomer
                isContactlessCustomer={!!designationId}
                designationId={designationId}
                  onCreateCustomer={(details: Customer) =>
                    {props.customerCreated?.(details?._id)
                      props.customerCreatedWithData?.(details) 
                    }
                  }
                  companyId={props.companyId}
                  phones={phones}
                  emails={emails}
                  isCompany360={props.isCompany360}
                  isCompanyCustomer={!props.isNormalCustomer}
                  gridColumns={3}
                  // onCancel={() => setStage("lead-details")}
                ></CreateCustomer>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default AddUser;
